import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
// const querystring = require("querystring");

const ManageContentTransformations = ({ location }) => {
  let parms = new URLSearchParams(location.search);

  const [state, setState] = useState({});
  useEffect(() => {}, []);
  return (
    <form>
      <div className="container-fluid">
        <h4>Manage Content Transformation</h4>
        <hr />
        <form columns="2">
          <div className="form-group row">
            <label
              className="ContentTitle col-sm-2"
              value="Content Transformation"
            >
              Content Transformation
            </label>
            <select
              id="contentTransformationId"
              onchange="submit()"
              className="form-control input-xlarge col-sm-8"
              value="#{contentTransformationForm.currentContentTransformation.contentTransformationId}"
              valueChangeListener="#{contentTransformationForm.get }"
            >
              <option value="#{contentTransformationForm.contentTransformationSelectList}" />
            </select>
          </div>
          <div className="form-group row">
            <label
              className="ContentTitle col-sm-2"
              value="Content Object Name"
            >
              Content Object Name
            </label>
            <input
              readOnly={true}
              id="contentName"
              className="form-control input-xlarge col-sm-8"
              value="#{contentTransformationForm.currentContentTransformation.contentName}"
            />
          </div>
          <div className="form-group row">
            <label
              className="ContentTitle col-sm-2"
              value="Content Transformation Description"
            >
              Content Transformation Description
            </label>
            <textarea
              id="contentTypeDescription"
              className="form-control input-xlarge col-sm-8"
              readOnly={true}
              value="#{contentTransformationForm.currentContentTransformation.contentTransformationDescription}"
            />
          </div>
          <div className="form-group row">
            <label className="ContentTitle col-sm-2" value="Transformation">
              Transformation
            </label>
            <select
              readOnly={true}
              id="transformationId"
              className="form-control input-xlarge col-sm-8"
              value="#{contentTransformationForm.currentContentTransformation.transformationId}"
            >
              <option value="#{contentTransformationForm.transformationSelectList}" />
            </select>
          </div>
        </form>
        <hr />
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Created By">
            Created By
          </label>
          <input
            className="form-control input-medium col-sm-1"
            readOnly={true}
            value="#{ombUserSession.getUserNameForId(contentTransformationForm.currentContentTransformation.createUser)}"
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="On">
            On
          </label>
          <input
            className="form-control input-medium col-sm-1"
            readOnly={true}
            value="#{contentTransformationForm.currentContentTransformation.createDate}"
          ></input>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Last Updated By ">
            Last Updated By
          </label>
          <input
            className="form-control input-medium col-sm-1"
            readOnly={true}
            value="#{ombUserSession.getUserNameForId(contentTransformationForm.currentContentTransformation.lastUpdateUser)}"
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="On">
            On
          </label>
          <input
            className="form-control input-medium col-sm-1"
            readOnly={true}
            value="#{contentTransformationForm.currentContentTransformation.lastUpdateDate}"
          ></input>
        </div>
        <hr />
        <button
          className="btn btn-success"
          value="Save"
          actionListener="#{contentTransformationForm.save}"
        >
          Save
        </button>
        &nbsp;
        <button
          className="btn btn-primary"
          value="Clear"
          actionListener="#{contentTransformationForm.clear}"
          immediate="true"
        >
          Clear
        </button>
        &nbsp;
        <button
          className="btn btn-danger"
          value="Delete"
          actionListener="#{contentTransformationForm.delete}"
        >
          Delete
        </button>
      </div>
    </form>
  );
};

export default ManageContentTransformations;
